import Index from "./index.vue"

export default [
  {
    path: "sales",
    name: "reports-sales",
    component: Index,
    title: "Sales",
  },
]
